import * as z from "zod";

type SettlementPaymentType =
    | "STRIPE"
    | "SWISH"
    | "GIFT_CARD"
    | "ON_PREMISE"
    | "FREE";

const settlementPaymentTypeZodEnum = z.enum([
    "STRIPE",
    "SWISH",
    "GIFT_CARD",
    "ON_PREMISE",
    "FREE",
]);

export { settlementPaymentTypeZodEnum };
export type { SettlementPaymentType };
